import React from 'react';
import {Box, Button, Switch, Typography} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {blue} from '@mui/material/colors';

const NAVIGATION_ACTION = {
    TODAY: 'TODAY',
    PREVIOUS: 'PREV',
    NEXT: 'NEXT'
};

const toggleStyle = {
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: blue[700],
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: blue[700],
    }
};

export default function SchedulePlannerNavigation({ onNavigate, onRefresh, showTimeblocks, setShowTimeblocks }) {
    const handleToggle = (event) => setShowTimeblocks(event.target.checked);

    return (
        <Box display="flex">
            <Button 
                className="icon-button-style"
                variant="contained"
                size="small"
                onClick={() => onNavigate(NAVIGATION_ACTION.PREVIOUS)}
                endIcon={<ArrowBackIosIcon />} />
            <Button 
                className="icon-button-style" 
                variant="contained" 
                size="small" 
                onClick={() => onNavigate(NAVIGATION_ACTION.NEXT)} 
                endIcon={<ArrowForwardIosIcon />} />
            <Button 
                className="button-style" 
                variant="contained" 
                size='small' 
                onClick={() => onNavigate(NAVIGATION_ACTION.TODAY)}>
                Today
            </Button>
            <Button 
                className="icon-button-style" 
                variant='contained' 
                size='small' 
                style={{padding: '0 0.4rem', width: '2rem'}} 
                onClick={onRefresh} 
                endIcon={<RefreshIcon />} />
            <Box display="flex" alignItems="center">
                <Switch 
                    checked={showTimeblocks} 
                    size="small" 
                    onChange={handleToggle} 
                    sx={toggleStyle} />
                <Typography>Show Timeblocks</Typography>
            </Box>
        </Box>
    );
}